"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _computeScrollIntoView = _interopRequireDefault(require("compute-scroll-into-view"));

var _Dropdown = require("./Dropdown.provider");

var _icons = require("../../assets/icons");

var _DropdownMenuItem = require("./DropdownMenuItem.styles");

var _util = require("../../util");

var _hooks = require("../../hooks");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Item = (0, _base["default"])("div", {
  target: "e1dk3t1i0",
  label: "Item"
})(_DropdownMenuItem.styles.base, ";");
var DropdownMenuItem = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      highlight = _ref.highlight,
      itemKey = _ref.itemKey,
      item = _ref.item,
      as = _ref.as,
      onClick = _ref.onClick,
      header = _ref.header,
      indent = _ref.indent,
      icon = _ref.icon,
      isWarning = _ref.isWarning,
      disabled = _ref.disabled,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["className", "children", "highlight", "itemKey", "item", "as", "onClick", "header", "indent", "icon", "isWarning", "disabled", "onMouseEnter", "onMouseLeave"]);

  var _useContext = (0, _react.useContext)(_Dropdown.DropdownContext),
      onSelect = _useContext.onSelect,
      selectedKey = _useContext.selectedKey,
      open = _useContext.open,
      highlightedItemKey = _useContext.highlightedItemKey,
      setHighlightedItemKey = _useContext.setHighlightedItemKey,
      setHasItemHighlightedByArrow = _useContext.setHasItemHighlightedByArrow,
      hasItemHighlightedByArrow = _useContext.hasItemHighlightedByArrow,
      triggerRef = _useContext.triggerRef,
      containerRef = _useContext.containerRef,
      isNavByArrowsDisabled = _useContext.isNavByArrowsDisabled;

  var itemRef = (0, _react.useRef)();
  var combinedRef = (0, _hooks.useCombinedRefs)(ref, itemRef);
  var handleSelect = (0, _react.useCallback)(function (e) {
    if (typeof onSelect === 'function') {
      onSelect(itemKey, item);
    }

    onClick(e, itemKey, item);
  }, [onSelect, onClick, itemKey, item]);
  var handleKeyDown = (0, _react.useCallback)(function (e) {
    (0, _util.handleEnter)(e, function () {
      e.preventDefault();

      if (itemRef.current) {
        // Trigger click event
        itemRef.current.click();
      }
    });
  }, []); // Focus the hovered element, so can trigger enter key event
  // and need to remove the highlightedItemKey

  var handleMouseEnter = (0, _react.useCallback)(function (e) {
    var _itemRef$current;

    if (onMouseEnter) {
      onMouseEnter(e);
    }

    if (isNavByArrowsDisabled) return;
    (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 ? void 0 : _itemRef$current.focus();
    setHasItemHighlightedByArrow(false);
    setHighlightedItemKey(itemKey);
  }, [itemKey, setHasItemHighlightedByArrow, setHighlightedItemKey, isNavByArrowsDisabled, onMouseEnter]); // Handle mouse leave the item

  var handleMouseLeave = (0, _react.useCallback)(function (e) {
    if (onMouseLeave) {
      onMouseLeave(e);
    }

    if (isNavByArrowsDisabled) return; // Blur the item element and focus the trigger element if the item element is focused

    if (document.activeElement === itemRef.current && triggerRef.current) {
      var _itemRef$current2;

      (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 ? void 0 : _itemRef$current2.blur();
      triggerRef.current.focus();
      setHighlightedItemKey();
    }
  }, [setHighlightedItemKey, triggerRef, isNavByArrowsDisabled, onMouseLeave]);
  (0, _react.useEffect)(function () {
    if (highlightedItemKey === itemKey && !isNavByArrowsDisabled) {
      var _itemRef$current3;

      // Focus the element, so can trigger enter event when press enter key
      (_itemRef$current3 = itemRef.current) === null || _itemRef$current3 === void 0 ? void 0 : _itemRef$current3.focus();
    }
  }, [highlightedItemKey, itemKey, isNavByArrowsDisabled]); // Scroll the selected item element into view on open the menu

  (0, _react.useEffect)(function () {
    if (open && selectedKey === itemKey) {
      var actions = (0, _computeScrollIntoView["default"])(itemRef.current, {
        boundary: containerRef.current,
        // Prevent the browser window from scrolling.
        block: 'nearest',
        scrollMode: 'if-needed'
      });
      actions.forEach(function (_ref2) {
        var el = _ref2.el,
            top = _ref2.top,
            left = _ref2.left;
        // eslint-disable-next-line no-param-reassign
        el.scrollTop = top; // eslint-disable-next-line no-param-reassign

        el.scrollLeft = left;
      });
    }
  }, [containerRef, itemKey, open, selectedKey]);
  var shouldShowHover = !header && !hasItemHighlightedByArrow;
  var isDisabled = header || disabled;
  return (0, _jsxRuntime.jsxs)(Item, _objectSpread(_objectSpread({
    as: as,
    ref: combinedRef,
    tabIndex: isDisabled ? -1 : 0,
    role: "menuitem",
    css: [shouldShowHover && _DropdownMenuItem.styles.hover, shouldShowHover && isWarning && _DropdownMenuItem.styles.negativeHover, highlight && _DropdownMenuItem.styles.highlight, header && _DropdownMenuItem.styles.header, indent && _DropdownMenuItem.styles.indent, process.env.NODE_ENV === "production" ? "" : ";label:DropdownMenuItem;"],
    className: (0, _clsx["default"])(className, {
      active: selectedKey === itemKey,
      highlighted: highlightedItemKey === itemKey,
      negative: isWarning,
      disabled: disabled
    }),
    onClick: !isDisabled ? handleSelect : undefined,
    onKeyDown: !isDisabled ? handleKeyDown : undefined,
    onMouseEnter: !isDisabled ? handleMouseEnter : undefined,
    onMouseLeave: !isDisabled ? handleMouseLeave : undefined
  }, otherProps), {}, {
    children: [icon ? (0, _jsxRuntime.jsxs)("div", {
      className: "grui flex items-center",
      css: _DropdownMenuItem.styles.contentWithIcon,
      children: [icon, children]
    }) : children, !header && (0, _jsxRuntime.jsx)("span", {
      css: _DropdownMenuItem.styles.icon,
      className: "dropdown-menu-item-icon",
      children: (0, _jsxRuntime.jsx)(_icons.Enter, {})
    })]
  }));
});
DropdownMenuItem.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]).isRequired,
  className: _propTypes.string,

  /**
   * Whether to add light-grey background and black-medium font
   */
  highlight: _propTypes.bool,

  /**
   * itemKey will be passed to onSelect function and be used for tracking hightlighted item
   */
  itemKey: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]).isRequired,

  /**
   * item will passed to onSelect function
   */
  item: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.bool, _propTypes.number, _propTypes.object]),

  /**
   * Change 'as' when want to use link for menu item,
   * that will make the arrow item be a part of link too,
   * otherwise click the arrow will not trigger redirect
   */
  as: _propTypes.elementType,
  onClick: _propTypes.func,

  /**
   * Display this menu item as a header. Setting to true
   * will disable interactions with this item and change
   * it's visual style.
   */
  header: _propTypes.bool,

  /**
   * Display this menu item as a sub item. Setting to true
   * will indent this item. Useful for grouping under a header.
   */
  indent: _propTypes.bool,

  /**
   * Add icon
   */
  icon: _propTypes.node,

  /**
   * Whether show warning styles for the menu item
   */
  isWarning: _propTypes.bool,
  disabled: _propTypes.bool,
  onMouseEnter: _propTypes.func,
  onMouseLeave: _propTypes.func
};
DropdownMenuItem.defaultProps = {
  className: undefined,
  highlight: false,
  item: undefined,
  as: 'div',
  onClick: function onClick() {},
  header: false,
  indent: false,
  icon: undefined,
  isWarning: false,
  disabled: false,
  onMouseEnter: undefined,
  onMouseLeave: undefined
};
DropdownMenuItem.displayName = 'DropdownMenuItem';
var _default = DropdownMenuItem;
exports["default"] = _default;
//# sourceMappingURL=DropdownMenuItem.js.map